import UIDs from "../../../../UIDs";

const uid = UIDs.screens.bbs.details;

const ActionTypes = {
    LOAD_SCREEN_VIEW_ASYNC: `${uid}.loadScreenViewAsync`,
    LOAD_SCREEN_VIEW_SUCCESS: `${uid}.loadScreenViewSuccess`,
    LOAD_SCREEN_VIEW_FAILURE: `${uid}.loadScreenViewFailure`,
    REFRESH_SCREEN_ASYNC: `${uid}.refreshScreenAsync`,
    REFRESH_SCREEN_SUCCESS: `${uid}.refreshScreenSuccess`,
    REFRESH_SCREEN_FAILURE: `${uid}.refreshScreenFailure`,
    LOAD_MORE_REPLY_ASYNC: `${uid}.loadMoreReplyAsync`,
    LOAD_MORE_REPLY_SUCCESS: `${uid}.loadMoreReplySuccess`,
    LOAD_MORE_REPLY_FAILURE: `${uid}.loadMoreReplyFailure`,
    LOAD_MORE_LIKE_ASYNC: `${uid}.loadMoreLikeAsync`,
    LOAD_MORE_LIKE_SUCCESS: `${uid}.loadMoreLikeSuccess`,
    LOAD_MORE_LIKE_FAILURE: `${uid}.loadMoreLikeFailure`,
    CHANGE_ACTIVE_TAB: `${uid}.changeActiveTab`,
    ADD_LIKE_ASYNC: `${uid}.addLikeAsync`,
    ADD_LIKE_SUCCESS: `${uid}.addLikeSuccess`,
    ADD_LIKE_FAILURE: `${uid}.addLikeFailure`,
    REMOVE_LIKE_ASYNC: `${uid}.removeLikeAsync`,
    REMOVE_LIKE_SUCCESS: `${uid}.removeLikeSuccess`,
    REMOVE_LIKE_FAILURE: `${uid}.removeLikeFailure`,
    ADD_FAVOURITE_ASYNC: `${uid}.addFavouriteAsync`,
    ADD_FAVOURITE_SUCCESS: `${uid}.addFavouriteSuccess`,
    ADD_FAVOURITE_FAILURE: `${uid}.addFavouriteFailure`,
    REMOVE_FAVOURITE_ASYNC: `${uid}.removeFavouriteAsync`,
    REMOVE_FAVOURITE_SUCCESS: `${uid}.removeFavouriteSuccess`,
    REMOVE_FAVOURITE_FAILURE: `${uid}.removeFavouriteFailure`,
    ADD_REPLY_ASYNC: `${uid}.addReplyAsync`,
    ADD_REPLY_SUCCESS: `${uid}.addReplySuccess`,
    ADD_REPLY_FAILURE: `${uid}.addReplyFailure`,
    REMOVE_REPLY_ASYNC: `${uid}.removeReplyAsync`,
    REMOVE_REPLY_SUCCESS: `${uid}.removeReplySuccess`,
    REMOVE_REPLY_FAILURE: `${uid}.removeReplyFailure`,
};

export { ActionTypes };
